<template>
  <div id="didaima">
    <div class="lunbo-box">
      <el-carousel :interval="5000" arrow="always" loop>
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <div class="banner-item" :style="{ backgroundImage: 'url(' + item.image + ')' }">
            <div v-if="item.title" class="banner-content">
              <h2>{{ item.title }}</h2>
              <p>{{ item.subtitle }}</p>
            </div>
            <!-- 第一张显示两个按钮 -->
            <template v-if="index === 0">
              <button class="btn" @click="handleDetail">查看详情</button>
              <button class="btn btn-white" @click="handleZX">售前咨询</button>
            </template>
            <!-- 第二张只显示一个按钮 -->
            <template v-if="index === 1">
              <button class="btn" @click="handleDetailT">即刻预约</button>
            </template>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="public-box">
      <div class="sub-title">产品系列</div>
      <div class="title-txt">小微/中大型/500强/国央企/政府/高校，适配不同企业需求，助力客户快速完成数字化转型</div>
    </div>

    <div class="box-1">
      <div
          class="product-card"
          v-for="(card, index) in cardList"
          :key="index"
          @click="handleCard(index)"
      >
        <img src="../assets/img/box2-bg2.png" class="bg" loading="lazy">
        <!-- 顶部横幅 -->
        <div class="card-header">
          <img :src="card.headerBg" class="bg" loading="lazy">
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-subtitle">{{ card.subtitle }}</p>
          <p class="card-subtitle2">{{ card.subtitle2 }}</p>
        </div>
        <!-- 功能列表 -->
        <div class="card-features">
          <div
              class="feature-item"
              v-for="(feature, idx) in card.features"
              :key="idx"
          >

            <div class="feature-text">
              <div style="display:flex;align-items: center">
                <img class="iconfont" :src="feature.icon" loading="lazy"></img>
                <span class="feature-title">{{ feature.title }}</span>
              </div>
              <p class="feature-desc">{{ feature.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box-2">
      <div class="public-box">
        <div class="sub-title color-w">垂直领域与行业数字化转型方案</div>
        <div class="title-txt color-w">来自60%中国500强和行业领军企业的共同选择</div>
      </div>

      <div class="container">
        <div class="left-nav">
          <div
              v-for="(item, index) in navList"
              :key="index"
              class="nav-item"
              :class="{ active: activeIndex2 === index }"
              @mouseenter="handleHover(index)"
          >
            {{ item }}
          </div>
        </div>

        <div class="right-box">
          <div class="right-top"></div>
          <div class="right-content-scroll">
            <div ref="rightContent" class="right-content" :style="contentStyle">
              <div
                  v-for="(item, index) in contentList"
                  :key="index"
                  class="content-item"
              >
                <h2 class="title">{{ item.title }}</h2>
                <p class="desc">{{ item.desc }}</p>
                <div class="icon-group">
                  <div
                      v-for="(icon, i) in item.iconslist"
                      :key="i"
                      class="icon-item"
                  >
                    <img :src="icon.icon" alt="icon" class="icon-img" loading="lazy">
                    <span class="icon-text">{{ icon.value }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="right-content-buttons">
            <button class="btn" @click="handleDetail">查看详情</button>
            <button class="btn btn-white" @click="handleZX">售前咨询</button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-box">
      <div class="sub-title">全面满足不同角色数字化诉求</div>
    </div>

    <div class="box-3 flex-row-around">
      <div class="card-content  flex-column-between" v-for="(item,index) in box3list" :key="index">
        <div class="title-txt">{{item.title}}</div>
        <div class="card-list">
          <div class="left-box">
            <div class="left-title">Before</div>
            <p class="before-item" v-for="(itm,idx) in item.Before" :key="idx">{{itm}}</p>
          </div>
          <div class="right-box">
            <div class="right-title">Now</div>
            <p class="after-item" v-for="(itm,idx) in item.Now" :key="idx">{{itm}}</p>
          </div>
          <img class="vs-logo" src="../assets/img/box3-03.png" loading="lazy">
        </div>
        <div class="btn" @click="handleZX">咨询服务</div>
      </div>
    </div>

    <div class="box-4">
      <div class="box-content">
        <p class="title">私有化部署解决方案</p>
        <p class="txt">为确保数据安全与隐私保护，我们提供完整的私有化部署方案。无论您是金融、</p>
        <p class="txt">医疗、政府还是其他行业，都能满足您的特定需求。</p>
        <div class="btn" @click="handleZX">您的专属解决方案咨询服务<i class="el-icon-right" style="font-size: 2rem;font-weight: 700;margin-left: 6px"></i></div>
      </div>

    </div>

    <div class="public-box">
      <div class="sub-title">来自各行各业的优秀实践</div>
    </div>

    <div class="box-5">
      <div class="top-box">
        <div
            class="btn"
            v-for="(btn, index) in box5list"
            :key="index"
            :class="{ active: activeIndex === index }"
            @click="handleBtnClick(index)"
        >
          {{ btn }}
        </div>
      </div>

      <transition name="scale-fade">
        <div :key="activeIndex" class="center-box">
          <div class="left-box">
            <p class="title">{{ box5list2[activeIndex].title }}</p>
            <p class="text">{{ box5list2[activeIndex].subtitle }}</p>
            <div class="flex-row">
              <div
                  v-for="(btn, index) in box5list2[activeIndex].children"
                  :key="index"
                  class="card"
              >
                <div class="number">{{ btn.lable }}</div>
                <div class="text">{{ btn.value }}</div>
              </div>
            </div>
            <div class="flex-row">
              <div class="btn1" @click="handleDetail">查看详情</div>
              <div class="btn2" @click="handleZX">售前咨询</div>
            </div>
          </div>
          <div class="right-box">
            <img :src="box5list2[activeIndex].img" alt="" class="img-animate" loading="lazy">
          </div>
        </div>
      </transition>
    </div>

    <div class="public-box">
      <div class="sub-title">标杆品牌的一致认可</div>
    </div>

    <div class="box-6">
      <div class="box-content">
        <img v-for="item in box6list1" :src="item.url" alt="" loading="lazy">
        <img v-for="item in box6list2" :src="item.url" alt="" loading="lazy">
        <img v-for="item in box6list3" :src="item.url" alt="" loading="lazy">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      bannerList: [
        {
          image: require("../assets/img/banner.png"),
          title: '',
          subtitle: ''
        },
        {
          image: require("../assets/img/zhibo.png"),
          title: '氚云AI，开启新智生产力时代',
          subtitle: '2026 氚云 AI 战略暨产品升级发布会'
        }
      ],
      cardList: [
        {
          title: '云枢',
          subtitle: '全面融合AI的低代码平台',
          subtitle2:'60%中国五百强企业选择的数智化引擎',
          headerBg: require("../assets/img/box2-card-01.png"),
          features: [
            {
              icon: require("../assets/img/box2-icon-01.png"),
              title: '多样化部署',
              desc: '支持公有云、私有云、专有云、混合云'
            },
            {
              icon: require("../assets/img/box2-icon-02.png"),
              title: 'AI智能',
              desc: '在开发设计层、业务应用层深度融合AI，打造AI应用设计器，让AI真正应需而生'
            },
            {
              icon: require("../assets/img/box2-icon-03.png"),
              title: '集成开放',
              desc: '全方位连接应用、数据、设备及生态，加强企业内外部协同、数据整合管理'
            },
            {
              icon: require("../assets/img/box2-icon-04.png"),
              title: '数据可视化',
              desc: '将数据转化为资产，助力企业程放数据价值，推动业务创新和决策优化'
            }
          ]
        },
        {
          title: '氚云',
          subtitle: '为企业组织数字化量身打造的开发工具',
          subtitle2:'连续8年钉钉全服市场销量前列',
          headerBg: require("../assets/img/box2-card-02.png"),
          features: [
            {
              icon: require("../assets/img/box2-icon-05.png"),
              title: '业务个性化',
              desc: '一站式搭建进销存、CRM等个性化应用'
            },
            {
              icon: require("../assets/img/box2-icon-06.png"),
              title: '全场景覆盖',
              desc: '提供各行业300+精品模板，开箱即用'
            },
            {
              icon: require("../assets/img/box2-icon-07.png"),
              title: '集成钉钉',
              desc: 'PC/移动高效协同，业务流程透明化'
            },
            {
              icon: require("../assets/img/box2-icon-08.png"),
              title: '全线打通',
              desc: '无缝衔接API接口，互通企业各端数据'
            }
          ]
        }
      ],
      box3list:[
        {
          title:'集团型企业',
          Before:['管理输出不明确','多系统维护成本高','数据孤岛问题突出','碎片化需求多'],
          Now:['可视化全流程把控','全场景数据统一管控','多样化数据集成方式','支持个性化业务需求']
        },
        {
          title:'中小型企业',
          Before:['业务流程不清晰','数据动态变换快','成品软件投入高','无专职开发人员'],
          Now:['自定义业务流程','资源信息及时共享','低代码产品提效降本','懂业务即可搭建系统']
        },
        {
          title:'个人开发者/团队',
          Before:['自行开发周期长','传统软件难操怍','小白不懂代码','人员协作效率低下'],
          Now:['丰富模板开箱即用','不受约束快速部署','0基础也能快速上手','在线协作自动化办公']
        }
      ],
      box6list1:[
        {
          url:require('../assets/img/box6-01.png')
        },
        {
          url:require('../assets/img/box6-02.png')
        },
        {
          url:require('../assets/img/box6-03.png')
        },
        {
          url:require('../assets/img/box6-04.png')
        },
        {
          url:require('../assets/img/box6-05.png')
        },
        {
          url:require('../assets/img/box6-06.png')
        },
        {
          url:require('../assets/img/box6-07.png')
        },
        {
          url:require('../assets/img/box6-08.png')
        },
        {
          url:require('../assets/img/box6-09.png')
        },
      ],
      box6list2:[
        {
          url:require('../assets/img/box6-10.png')
        },
        {
          url:require('../assets/img/box6-11.png')
        },
        {
          url:require('../assets/img/box6-12.png')
        },
        {
          url:require('../assets/img/box6-13.png')
        },
        {
          url:require('../assets/img/box6-14.png')
        },
        {
          url:require('../assets/img/box6-15.png')
        },
        {
          url:require('../assets/img/box6-16.png')
        },
        {
          url:require('../assets/img/box6-17.png')
        },
        {
          url:require('../assets/img/box6-18.png')
        },
      ],
      box6list3:[
        {
          url:require('../assets/img/box6-19.png')
        },
        {
          url:require('../assets/img/box6-20.png')
        },
        {
          url:require('../assets/img/box6-21.png')
        },
        {
          url:require('../assets/img/box6-22.png')
        },
        {
          url:require('../assets/img/box6-23.png')
        },
        {
          url:require('../assets/img/box6-24.png')
        },
        {
          url:require('../assets/img/box6-25.png')
        },
        {
          url:require('../assets/img/box6-26.png')
        },
        {
          url:require('../assets/img/box6-27.png')
        },
      ],
      box5list:[
          '国央企', '专精特新', '金融', '建筑', '制造',
        '汽车', '石油石化', '房地产',
      ],
      box5list2:[
        {
          title:'中建某局',
          subtitle:'中建某局作为建筑行业领导者，借助云枢构建了精益建造数字化平台，涵盖运营管理、项目管理，实现项目全生命周期管理。',
          children:[
            {
              lable:'三级管理体系',
              value:'集团分公司项目部'
            },
            {
              lable:'业务强协同',
              value:'实现商务招采生产'
            },
          ],
          img:require('../assets/img/box5-01.png')
        },
        {
          title:'曦强乳业',
          subtitle:'作为安徽省农业龙头企业，曦强乳业通过氚云成功建立产品溯源体系，最终形成了牧场-工厂-门店-消费者的全链路数字化。',
          children:[
            {
              lable:'10%',
              value:'使用人员数量提升'
            },
            {
              lable:'90%',
              value:'集团应用场景占比'
            },
          ],
          img:require('../assets/img/box5-02.png')
        },
        {
          title:'民生证券',
          subtitle:'作为中国成立最早的证券公司之一，民生证券通过云枢自主构建安全可控的一站式敏捷研发平台，涵盖客户管理、投后管理、外包管理等应用，实现金融业务的快速迭代和创新。',
          children:[
            {
              lable:'自主创新',
              value:'平台自主可控'
            },
            {
              lable:'全生命周期',
              value:'机构客户管理实现'
            },
          ],
          img:require('../assets/img/box5-03.png')
        },
        {
          title:'云南建投',
          subtitle:'云南建投围绕人和物，通过氚云搭建实名制管理平台，规范了18万农民工的管理；搭建物资管理平台，满足了国内外所有项目的供应需求。',
          children:[
            {
              lable:'实名制管理',
              value:'实现18万农民工'
            },
            {
              lable:'从人到物',
              value:'管理覆盖全项目'
            },
          ],
          img:require('../assets/img/box5-04.png')
        },
        {
          title:'中海达',
          subtitle:'中海达是测绘装备制造领域第一家上市公司。通过云枢，中海达自主搭建了项目运营管理平台，完成了集团与分公司资源的统一整合，为企业管理决策提供支持。',
          children:[
            {
              lable:'资源统一',
              value:'实现集团与分公司'
            },
            {
              lable:'科学决策',
              value:'助力经营管理'
            },
          ],
          img:require('../assets/img/box5-05.png')
        },
        {
          title:'保时捷',
          subtitle:'作为全球知名的豪华汽车品牌，保时捷通过云枢自主构建的数字化平台打通全国经销商管理，实现跨系统数据流通和业务协同，成功打破管理边界。',
          children:[
            {
              lable:'高效管理',
              value:'实现100+经销商'
            },
            {
              lable:'全面统一',
              value:'业务流程实现'
            },
          ],
          img:require('../assets/img/box5-06.png')
        },
        {
          title:'茂名石化',
          subtitle:'茂名石化作为炼化企业领导者，是国家能源安全的重要保障力量。通过云枢低代码，茂名石化实现了质量安全全流程管理，打造出具有中国石化特色的一体化管理标准体系。',
          children:[
            {
              lable:'安全管理',
              value:'实现质量安全体系'
            },
            {
              lable:'建立标准',
              value:'构建制度流程标准'
            },
          ],
          img:require('../assets/img/box5-07.png')
        },
        {
          title:'建发集团',
          subtitle:'作为“中国房地产开发企业50强”和“中国物业服务企业百强”，通过云枢低代码构建了统一的流程中心，同时整合原有业务系统，实现投资管理、房开管理、建管合同等业务重构升级。',
          children:[
            {
              lable:'统一流程中台',
              value:'提升集团管理效率'
            },
            {
              lable:'集约化研发管理模式',
              value:'实现快速交付与变更'
            },
          ],
          img:require('../assets/img/box5-08.png')
        },
      ],
      activeIndex: 0,
      navList: [
        "应用开发平台",
        "建筑行业",
        "金融行业",
        "汽车行业",
        "石油石化",
        "CRM营销",
      ],
      contentList: [
        {
          title: "应用开发平台解决方案",
          desc: "面向业务数字原生时代，以领域模型驱动的低代码开发平台，提供全套可视化开发工具，以拖拉拽形式快速搭建核心数字化系统，帮助国央企和大型集团实现企业数字化能力构建与业务创新。",
          iconslist:[
            {
              value:'统一技术平台',
              icon: require("../assets/img/box2-01.png"),
            },
            {
              value:'领域驱动设计',
              icon: require("../assets/img/box2-02.png"),
            },
            {
              value:'装配式开发',
              icon: require("../assets/img/box2-03.png"),
            },
            {
              value:'应用管理',
              icon: require("../assets/img/box2-04.png"),
            },
            {
              value:'研发资产沉淀',
              icon: require("../assets/img/box2-05.png"),
            },
          ]
        },
        {
          title: "建筑行业解决方案",
          desc: "为大中型建筑企业量身定制的精益建造解决方案，围绕合同管理、项目管理、经营管理、产业链协同，帮助企业打造一体化融合及生态体系建设与共享的数字化升级方案。",
          iconslist:[
            {
              value:'精益建造',
              icon: require("../assets/img/box2-06.png"),
            },
            {
              value:'工程项目管理',
              icon: require("../assets/img/box2-07.png"),
            },
            {
              value:'合同管理',
              icon: require("../assets/img/box2-08.png"),
            },
            {
              value:'流程中台',
              icon: require("../assets/img/box2-09.png"),
            },
            {
              value:'经营管理',
              icon: require("../assets/img/box2-10.png"),
            },
            {
              value:'安全质量管理',
              icon: require("../assets/img/box2-11.png"),
            },
          ]
        },
        {
          title: "金融行业解决方案",
          desc: "将“低代码开发平台+RPA”等前沿技术深度融入实际业务场景中，快速部署和上线新应用，促进业技融合的高效协同，实现自动化开发与智能化开发。",
          iconslist:[
            {
              value:'流程自动化',
              icon: require("../assets/img/box2-12.png"),
            },
            {
              value:'快速应用开发',
              icon: require("../assets/img/box2-13.png"),
            },
            {
              value:'业务系统集成',
              icon: require("../assets/img/box2-14.png"),
            },
            {
              value:'自动化助手',
              icon: require("../assets/img/box2-15.png"),
            },
            {
              value:'清算自动化',
              icon: require("../assets/img/box2-16.png"),
            },
            {
              value:'金融资产管理',
              icon: require("../assets/img/box2-17.png"),
            },
          ]
        },
        {
          title: "汽车行业解决方案",
          desc: "聚焦汽车企业流程管理、应用开发痛难点，打造“研、产、供、销、服”全业务场景一体化，建立统一的流程，实现企业标准化管理，提升车企市场竞争力，实现可持续的盈利性增长。",
          iconslist:[
            {
              value:'流程中台',
              icon: require("../assets/img/box2-18.png"),
            },
            {
              value:'SRM',
              icon: require("../assets/img/box2-19.png"),
            },
            {
              value:'质量管理',
              icon: require("../assets/img/box2-20.png"),
            },
            {
              value:'设备管理',
              icon: require("../assets/img/box2-21.png"),
            },
            {
              value:'经销商管理',
              icon: require("../assets/img/box2-22.png"),
            },
            {
              value:'4S门店管理',
              icon: require("../assets/img/box2-23.png"),
            },
          ]
        },
        {
          title: "石油石化解决方案",
          desc: "针对行业工程质量和进度管控难、管理效率低等痛点，提供集成制度流程管理、工程项目管理、检维修管理等一体化运营管理解决方案，加快推进石油石化行业数字化升级。",
          iconslist:[
            {
              value:'流程中心',
              icon: require("../assets/img/box2-24.png"),
            },
            {
              value:'协同办公',
              icon: require("../assets/img/box2-25.png"),
            },
            {
              value:'变更管理',
              icon: require("../assets/img/box2-26.png"),
            },
            {
              value:'检维修管理',
              icon: require("../assets/img/box2-27.png"),
            },
            {
              value:'制度一体化',
              icon: require("../assets/img/box2-28.png"),
            },
            {
              value:'项目管理',
              icon: require("../assets/img/box2-29.png"),
            },
          ]
        },
        {
          title: "CRM营销解决方案",
          desc: "对获客-营销-签单-售后服务进行全流程自动化管理，打造以客户为中心、以服务为导向的销售管理模式，实现从线索到回款的高效运营，全面推进销售业绩增长。",
          iconslist:[
            {
              value:'商机管理',
              icon: require("../assets/img/box2-30.png"),
            },
            {
              value:'客户管理',
              icon: require("../assets/img/box2-31.png"),
            },
            {
              value:'订单管理',
              icon: require("../assets/img/box2-32.png"),
            },
            {
              value:'合同管理',
              icon: require("../assets/img/box2-33.png"),
            },
            {
              value:'售后服务',
              icon: require("../assets/img/box2-34.png"),
            },
            {
              value:'财务回款',
              icon: require("../assets/img/box2-35.png"),
            },
          ]
        },
      ],
      activeIndex2: 0, // 当前激活的左侧按钮索引
      iconText: [
        "统一技术平台",
        "领域驱动设计",
        "装配式开发",
        "应用管理",
        "研发资产沉淀",
      ],
      // 每个内容的高度（需与设计一致，影响滚动距离）
      itemHeight: 467,

    }
  },
  computed: {
    contentStyle() {
      // 计算 translateY 值：-索引 * 单内容高度
      const translateY = - this.activeIndex2 * this.itemHeight;
      return {
        // 核心滚动逻辑
        transform: `translate3d(0px, ${translateY}px, 0px)`,
        // 过渡时长设为 1s（可自定义，越大越慢）
        transitionDuration: "0.5s",
        // 缓动曲线：让滚动有“弹性”感
        transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)",
      };
    },
  },
  methods:{
    handleBtnClick(index){
      this.activeIndex = index;
    },
    handleHover(index) {
      this.activeIndex2 = index;
      // 强制重绘（可选，解决偏移问题）
      this.$nextTick(() => {
        const contentDom = this.$refs.rightContent;
        // contentDom.style.transform = `translate3d(0px, -${index * 270}px, 0px)`;
        contentDom.style.transform = `translate3d(0px, -${index * 30}rem, 0px)`;
      });
    },
    handleDetail(){
      window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
    },
    handleZX() {
      window.open('https://ada.baidu.com/site/wjzkc6f4/agent?imid=5d91d676c2c61e803f929d52269380db&showpageinpc=1')
    },
    handleCard(index){
      if(index==0){
        this.$router.push({name:'yunshu'})
      } else {
        this.$router.push({name:'chuanyun'})
      }
    },
    handleDetailT(){
      this.$router.push({name:'zhibo'})
    }
  }
}
</script>

<style lang='less' scoped>
#didaima {
  user-select: none;
  .lunbo-box {
    width: 100%;
    height: 798px;
    margin: 0 auto;
    .el-carousel {
      width: 100%;
      height: 100%;
      /deep/ .el-carousel__container {
        height: 100% !important;
      }
      .el-carousel__item {
        height: 100%;
      }
      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }
      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .banner-item {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: relative;
      .banner-content {
        position: absolute;
        top: 15rem;
        left: 14rem;
        h2 {
          font-size: 90px;
          color: #2d72f8;
          margin-bottom: 20px;
          font-weight: bold;
        }
        p {
          font-size: 34px;
          color: black;
          margin-bottom: 50px;
          text-align: left;
        }
      }
      .btn {
        width: 13.4rem;
        height: 4.4rem;
        font-size: 24px;
        border: none;
        border-radius: 0.3rem;
        background: #007aff;
        color: #fff;
        cursor: pointer;
        transition: background 0.3s;
        position: absolute;
        top: 35.8rem;
        left: 14rem;
        cursor: pointer;
      }
      .btn:hover { background: #005ee6; }
      .btn-white {
        background: #fff;
        color: #007aff;
        border: 2px solid #007aff;
        position: absolute;
        top: 35.8rem;
        left: 30.6rem;
      }
      .btn-white:hover { background: #f2f2f2; }
    }
  }

  .box-1 {
    display: flex;
    gap: 24px;
    justify-content: center;
    height: 81rem;
    background: url("../assets/img/box2-bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 2rem 0;
    .product-card {
      min-width: 64rem;
      overflow: hidden;
      transition: all 0.3s ease;
      position: relative;
      cursor: pointer;
      margin-top: 20px;
      .bg{
        width: 100%;
        height: 100%;
      }
      //  hover 动效
      &:hover {
        transform: translateY(-15px);
      }
    }

    .card-header {
      height: 22rem;
      color: white;
      position: absolute;
      top:0;
      left: 0;
      right: 0;
      z-index: 9;
      .bg{
        width: 96.3%;
        height: 100%;
        position: relative;
      }

      .card-title {
        font-size: 56px;
        font-weight: 600;
        margin-bottom: 8px;
        text-shadow: 0 2px 4px rgba(0,0,0,0.2);
        position: absolute;
        z-index: 99;
        top:20%;
        left: 10%;
      }

      .card-subtitle {
        font-size: 32px;
        line-height: 1.6;
        opacity: 0.9;
        text-shadow: 0 1px 2px rgba(0,0,0,0.3);
        position: absolute;
        z-index: 99;
        top:50%;
        left: 10%;
      }
      .card-subtitle2{
        font-size: 32px;
        line-height: 1.6;
        opacity: 0.9;
        text-shadow: 0 1px 2px rgba(0,0,0,0.3);
        position: absolute;
        z-index: 99;
        top:65%;
        left: 10%;
      }
    }

    .card-features {
      text-align: left;
      padding: 4.74rem 4.1rem;
      position: absolute;
      top:30%;
      left: 0;
      right: 0;
      z-index: 9;


      .feature-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 54px;

        .iconfont {
          width: 4rem;
          height:4rem;
          margin-right: 20px;
          flex-shrink: 0;
          margin-bottom: 14px;
        }

        .feature-text {
          //flex: 1;

          .feature-title {
            font-size: 32px;
            font-weight: 500;
            letter-spacing: 0px;
            color: rgba(0, 137, 255, 1);
            text-align: left;
          }

          .feature-desc {
            font-size: 24px;
            font-weight: 400;
            letter-spacing: 1px;
            color: rgba(75, 85, 99, 0.9);
            text-align: justify;
          }
        }
      }
    }
  }

  .box-3{
    width: 80%;
    margin: 0 auto;
    .card-content{
      width: 33%;
      height: 100%;
      display: flex;

    }
    .title-txt{
      font-size: 48px;
      font-weight: 500;
      color: rgba(0, 53, 99, 1);
      margin-bottom: 40px;
    }
    .card-list{
      width: 40.5rem;
      height: 29.92rem;
      position: relative;
      display: flex;
      .left-box{
        width: 45%;
        height: 80%;
        text-align: left;
        position: absolute;
        top: 10%;
        font-size: 22px;
        color: rgba(120, 120, 120, 1);
        border-radius: 16px;
        background: rgba(242, 245, 250, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        p{
          margin: 35px 20px;
        }
      }
      .right-box{
        width: 57%;
        height: 100%;
        text-align: left;
        color: white;
        font-size: 26px;
        font-weight: 500;
        position: absolute;
        right: 0;
        border-radius: 11px;
        background: rgba(0, 137, 255, 1);
        box-shadow: -6px 2px 16px  rgba(136, 165, 191, 0.48), 6px -2px 16px  rgba(255, 255, 255, 0.8);
        p{
          margin: 40px 0px 40px 70px;
        }
      }
      .vs-logo{
        width: 6rem;
        height: 6rem;
        position: absolute;
        top:43%;
        left: 35%;
      }
      .before-item, .after-item{
        position: relative; /* 关键：让伪元素相对当前div定位 */
        padding-left: 30px; /* 预留图片位置，避免文字与图片重叠 */
        margin-bottom: 8px; /* 可选：添加项间距 */
      }
      .before-item::before {
        content: ''; /* 伪元素必须有content，可空 */
        /* 定位：在div左侧 */
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); /* 垂直居中 */
        /* 图片尺寸 */
        width: 20px;
        height: 20px;
        /* 引入图片（替换为你的图片路径） */
        background-image: url('../assets/img/box3-01.png'); /* 本地图片 */
        /* 或网络图片：background-image: url('https://xxx.com/icon.png'); */
        background-size: cover; /* 图片自适应尺寸 */
        background-repeat: no-repeat; /* 防止图片重复 */
        background-position: center; /* 图片居中显示 */
      }
      .after-item::before {
        content: ''; /* 伪元素必须有content，可空 */
        /* 定位：在div左侧 */
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); /* 垂直居中 */
        /* 图片尺寸 */
        width: 20px;
        height: 20px;
        /* 引入图片（替换为你的图片路径） */
        background-image: url('../assets/img/box3-02.png'); /* 本地图片 */
        /* 或网络图片：background-image: url('https://xxx.com/icon.png'); */
        background-size: cover; /* 图片自适应尺寸 */
        background-repeat: no-repeat; /* 防止图片重复 */
        background-position: center; /* 图片居中显示 */
      }
      .left-title{
        font-size: 32px;
        font-weight: 400;
        color: rgba(120, 120, 120, 1);
        margin: 40px 0 0px 20px;
      }
      .right-title{
        font-size: 32px;
        font-weight: 700;
        color: white;
        margin: 60px 0px 30px 70px;
      }
    }

    .btn{
      width: 16.62rem;
      height: 4.32rem;
      line-height: 4.32rem;
      border-radius: 6px;
      color: white;
      font-size: 26px;
      text-align: center;
      vertical-align: center;
      cursor:pointer;
      margin: 74px 0 94px 0;
      background: rgba(0, 137, 255, 1);
    }
    .btn:hover { background: #005ee6; }
  }

  .box-4{
    height: 40.81rem;
    width: 100%;
    background: url("../assets/img/box4-bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .box-content{
      width: 80%;
      height: 100%;
      margin: 0 auto;
      color: white;
      text-align: left;
    }
    .title{
      font-size: 54px;
      font-weight: 700;
      padding-top: 98px;
      padding-bottom: 40px;
    }
    .txt{
      font-size: 32px;
      font-weight: 500;
      letter-spacing: 1px;
      padding: 10px 0;
    }
    .btn{
      width: 28rem;
      height: 4.9rem;
      font-size: 26px;
      font-weight: 500;
      border-radius: 10px;
      background: rgba(255, 141, 26, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 93px;
      cursor: pointer;
    }
    .btn:hover{
      background: rgba(255, 141, 26, 0.9);
    }
  }

  .box-5{
    width: 80%;
    height: 44rem;
    margin: 0 auto;
    position: relative;
    min-height: 44rem; /* 防止切换时高度跳动 */
    .top-box{
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      /* 按钮基础样式 */
      .btn {
        width: 11.63rem;
        height: 4.32rem;
        line-height: 4.32rem;
        border-radius: 12px;
        background: rgba(240, 247, 255, 1);
        font-size: 24px;
        font-weight: 400;
        color: rgba(0, 137, 255, 1);
        cursor: pointer;
        transition: all 0.3s ease; /* 过渡动画，让激活效果更平滑 */
        user-select: none; /* 禁止选中文字 */
      }

      /* 鼠标悬停样式 */
      .btn:hover {
        border-color: #409eff;
        color: #409eff;
      }

      /* 激活态样式（点击后） */
      .btn.active {
        background-color: #409eff;
        color: white;
        border-color: #409eff;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3); /* 激活时添加阴影增强效果 */
      }

      /* 激活态鼠标悬停样式（可选） */
      .btn.active:hover {
        background-color: rgba(53, 136, 225, 0.99); /* 略深一点的蓝色，增强交互反馈 */
      }
    }
    .center-box{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
      .left-box{
        width: 52%;
        height: 33.66rem;
        text-align: left;
        .btn1{
          width: 13.3rem;
          height: 4.3rem;
          line-height: 4.3rem;
          text-align: center;
          border-radius: 6px;
          color: white;
          font-size: 24px;
          margin-right: 54px;
          background: rgba(0, 137, 255, 1);
          margin-top: 30px;
          cursor: pointer;
          box-shadow:  rgba(0, 0, 0, 0.1), 0px 4px 6px -4px;
        }
        .btn2{
          width: 13.3rem;
          height: 4.3rem;
          line-height: 4.3rem;
          text-align: center;
          border-radius: 6px;
          font-size: 24px;
          color: rgba(0, 137, 255, 1);
          background: rgba(255, 255, 255, 1);
          margin-top: 30px;
          border: 1px solid rgba(0, 137, 255, 1);
          cursor: pointer;
        }

        .btn1:hover { background: #005ee6; }
        .btn2 {
          background: #fff;
          color: #007aff;
        }
        .btn2:hover { background: #f2f2f2; }
      }

      .right-box{
        width: 35%;
        border-radius: 16px;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          //transition: all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
        }
        .img-animate:hover{
          transform: scale(1.2);
        }

      }

      .title{
        font-size: 42px;
        font-weight: 500;
        letter-spacing: 1px;
        color: rgba(0, 137, 255, 1);
        margin-bottom: 26px;
      }
      .text{
        font-size: 24px;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(75, 85, 99, 0.9);
        line-height: 40px;
      }
    }
    .card{
      width: 16rem;
      height: 8.31rem;
      border-radius: 8px;
      background: rgba(240, 247, 255, 1);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin:72px 54px 72px 0;
    }
    .number{
      font-size: 28px;
      font-weight: 500;
      letter-spacing: 0px;
      color: rgba(0, 137, 255, 1);
    }
    .text{
      font-size: 22px;
      font-weight: 400;
      color: rgba(75, 85, 99, 1);
    }
    /* 缩放+淡入淡出过渡效果 */
    .scale-fade-enter-from,
    .scale-fade-leave-to {
      opacity: 0; /* 完全透明 */
    }

    .scale-fade-enter-active {
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); /* 加速-减速曲线，更有弹性 */
    }

    .scale-fade-leave-active {
      transition: all 0.2s ease-out; /* 离开时稍快，平滑淡出 */
      position: absolute;
      width: 100%;
    }

  }

  .box-6{
    width: 100%;
    height: 28rem;
    background: url("../assets/img/box6-bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin-bottom: 100px;
    .box-content{
      width: 80%;
      height: 100%;
      margin: 0 auto;
      padding: 40px 0;
      img{
        width: 13rem;
        height: 6rem;
        margin: 8px;
        transition: transform 0.3s ease;
      }
      img:hover {
        transform: scale(1.1); /*  hover 时放大10%，有过渡效果 */
      }
    }
  }

  .btn1{
    width: 13.3rem;
    height: 4.3rem;
    line-height: 4.3rem;
    text-align: center;
    border-radius: 6px;
    color: white;
    font-size: 24px;
    margin-right: 54px;
    background: rgba(0, 137, 255, 1);
    margin-top: 30px;
    cursor: pointer;
    box-shadow:  rgba(0, 0, 0, 0.1), 0px 4px 6px -4px;
  }
  .btn2{
    width: 13.3rem;
    height: 4.3rem;
    line-height: 4.3rem;
    text-align: center;
    border-radius: 6px;
    font-size: 24px;
    color: rgba(0, 137, 255, 1);
    background: rgba(255, 255, 255, 1);
    margin-top: 30px;
    border: 1px solid rgba(0, 137, 255, 1);
    cursor: pointer;
  }

  .btn1:hover { background: #005ee6; }
  .btn2 {
    background: #fff;
    color: #007aff;
  }
  .btn2:hover { background: #f2f2f2; }

}
</style>
<style lang="less" scoped>

.public-box{
  width: 100%;
  height: 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 3rem;
}
.sub-title{
  font-size: 80px;
  font-weight: 500;
  letter-spacing: 2px;
  color: rgba(0, 0, 0, 1);
}
.title-txt{
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 20px;
}

.color-w{
  color:white;
}

.flex-column-between{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex-row-around{
  display: flex;
  justify-content: space-around;
}
.flex-row{
  display: flex;
}
</style>
<style lang="less" scoped>
#didaima {
  .box-5 {

    /* 图片过渡与动画 */
    .img-animate {
      /* 基础过渡（0.3秒） */
      transition: all 0.3s;

      /* 初始状态（为动画做准备） */
      transform: scale(1);
    }

    /* 当图片进入视图时触发动画 */
    .scale-fade-enter-active .img-animate {
      animation: imgZoom 1s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  .scale-fade-enter-active .img-animate {
    animation: imgZoom 1s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  /* 定义图片缩放动画细节 */
  @keyframes imgZoom {
    0% {
      transform: scale(0.8); /* 初始缩小到90% */
      opacity: 1; /* 完全透明 */
    }
    60% {
      transform: scale(1.08); /* 中间轻微放大到108% */
      opacity: 1; /* 完全显示 */
    }
    100% {
      transform: scale(1); /* 恢复正常大小 */
    }
  }
}
</style>
<style lang="less" scoped>
.box-2 {
  width: 100%;
  height: 80rem;
  background: url("../assets/img/bg.jpeg") center/cover no-repeat;
  .container {
    width: 80%;
    height: 45rem;
    margin: 0 auto;
    display: flex;
    overflow: hidden;
    background-color: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
  }
  /* 左侧导航（不变） */
  .left-nav {
    width: 25%;
    display: flex;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    padding: 1.5rem 0;
    box-sizing: border-box;
  }
  .nav-item {
    width: 90%;
    padding: 20px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
    transition: background 0.3s;
    color: white;
    border-radius: 0.5rem;
    margin: 1rem auto;
  }
  .nav-item:hover { background: #007aff; }
  .nav-item.active { background: #007aff; }
  /* 右侧整体布局：用 flex 垂直拆分 */
  .right-box {
    width: 60%;
    display: flex;
    flex-direction: column; /* 垂直排列子元素 */
    margin: 0 auto;
  }
  .right-top{
    flex: 1; /* 占 8 份，总 10 份 */
  }
  /* 内容滚动区：占 80% 高度，允许滚动 */
  .right-content-scroll {
    flex: 7; /* 占 8 份，总 10 份 */
    overflow: hidden; /* 隐藏超出部分，由 translate 控制滚动 */
    border-bottom: 2px solid #89939d;
  }
  .right-content {
    height: 100%;
    //background: #1a84ee;
    width: 100%;
    transition: transform 0.6s cubic-bezier(0.25, 0.1, 0.25, 1);
    will-change: transform;
  }
  .content-item {
    height: 30rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  /* 按钮固定区：占 20% 高度，固定在底部 */
  .right-content-buttons {
    flex: 2; /* 占 2 份，总 10 份 */
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
  }
  .btn {
    width: 13.3rem;
    height: 4.3rem;
    font-size: 24px;
    border: none;
    border-radius: 0.3rem;
    background: #007aff;
    color: #fff;
    cursor: pointer;
    transition: background 0.3s;
  }
  .btn:hover { background: #005ee6; }
  .btn-white {
    background: #fff;
    color: #007aff;
  }
  .btn-white:hover { background: #f2f2f2; }
  /* 内容样式（不变） */
  .title {
    color: white;
    font-size: 36px;
    text-align: left;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .desc {
    color: white;
    font-size: 28px;
    text-align: left;
    margin-bottom: 30px;
  }
  .icon-group {
    display: flex;
    gap: 30px;
    margin-top: 5rem;
  }
  .icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .icon-img {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  .icon-text {
    font-size: 22px;
    color: white;
  }
}
</style>
<style lang='less' >
.el-carousel__arrow{
  margin-left: 5rem;
  width: 6rem;
  height: 6rem;
  font-size: 4rem;
}
.el-carousel__arrow--right{
  margin-right: 5rem;
}
</style>
